exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".chat-not-selected__image-parent{\n  height: 60%;\n  width: 60%;\n}\n.chat-not-selected__image{\n  width: 100%;\n  height: 100%;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/ChatNotSelected/ChatNotSelected.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/ChatNotSelected/ChatNotSelected.css
// module chunks = 120